var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrianglePause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09524 0.0119055C1 0.0595246 0.047619 0.916657 0 2.20237V15.9167C0.047619 17.5833 1.71429 18.6309 3.19048 17.8214L15.0952 10.9166C15.7619 10.5357 16.1905 9.86905 16.1905 9.05952C16.1905 8.25 15.7619 7.58332 15.0952 7.20237L3.19048 0.297609C2.80952 0.059514 2.42857 -0.0357135 2.09524 0.0119055Z",
    fill: "#81818C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglePause);
export default __webpack_public_path__ + "static/media/TrianglePause.3b2d4b24.svg";
export { ForwardRef as ReactComponent };